import request from './request';

/*
 * 연결 가능한 VD 그룹을 가져옴
 */
export async function getAvailableVdGroups() {
  const res = await request.get(`/portal/api/session/vdgroups`, {
    headers: { Pragma: 'no-cache' },
  });
  return res.data;
}

export async function getAvailableVdDetail(id) {
  const res = await request.get(`/portal/api/session/vdgroups/${id}`, {
    headers: { Pragma: 'no-cache' },
  });
  return res.data;
}

/*
 * VD 제어(전원켜기, 재시작...)
 */
export async function requestVdAction(groupId, action) {
  const res = await request.post(`/portal/api/session/vdgroups/${groupId}/${action}`);
  return res;
}

/*
 * 자동 접속할 vd 설정 저장
 */
export async function saveAutoLoginVd(vdGroupId) {
  const res = await request.post(`/portal/api/session/vdgroups/autologin`, vdGroupId);
  return res;
}
